import React from "react";
import Marquee from "react-fast-marquee";
import { SITE } from "@/data/site";
import { useLang } from "@/contexts/LanguageContext";

const BrandTicker = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="brand-ticker"
      className="border-y border-[#E5E7EB] bg-white/50"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-10 sm:py-12">
        <div className="flex flex-col lg:flex-row lg:items-center lg:gap-14 gap-6">
          <div className="lg:w-1/4 flex-shrink-0">
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#4B5563] font-semibold">
              {t("common.trustedBrands")}
            </span>
            <div className="mt-2 h-px w-12 bg-[#082133]/30" />
          </div>
          <div className="lg:w-3/4 ticker-fade">
            <Marquee gradient={false} speed={45} pauseOnHover>
              {SITE.brands.concat(SITE.brands).map((b, i) => (
                <span
                  key={`${b}-${i}`}
                  data-testid={`brand-${b.toLowerCase()}-${i}`}
                  className="font-display text-2xl sm:text-3xl tracking-[0.18em] uppercase text-[#082133]/40 hover:text-[#082133] transition-colors mx-10"
                >
                  {b}
                </span>
              ))}
            </Marquee>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandTicker;
